import { EmailAddress } from '@constants';
import { useSelector } from 'react-redux';
import classes from './index.module.css';

// OP-2709 17BP用户可能因为订单没有fulfilled 而不能完成报案，或者有其他原因阻塞完成报案，为降低消费者联系商家的几率，提供消费者联系我们的渠道,或者提供comment渠道。
export const WrongInfo = ({ name, status }) => {
  const { type, orderNumber } = useSelector((state) => state.claim);
  const { firstName } = useSelector((state) => state.policy);
  const handleSendShippingEmail = () => {
    const a = document.createElement('a');
    a.href = `mailto:${EmailAddress.Seel}?subject=Reporting Wrong Shipping Information&body=${encodeURIComponent(`Dear Seel team,\n\nI am unable to report my package ${type} due to inaccurate shipping information. Please help verify and update the latest shipping status of below package to facilitate the resolution process for my package issue.\nOrder Number: ${orderNumber} (${name})\nCurrent Shipping Status: ${status}\n\nThanks,\n${firstName || ''}`)}`;
    a.innerHTML = EmailAddress.Seel;

    a.click();
  };
  return (

    <section onClick={handleSendShippingEmail} className={classes.report_info}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M13 10C13 10.5523 13.4477 11 14 11C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9C13.4477 9 13 9.44772 13 10ZM9 10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10ZM5 10C5 10.5523 5.44772 11 6 11C6.55228 11 7 10.5523 7 10C7 9.44772 6.55228 9 6 9C5.44772 9 5 9.44772 5 10ZM10 2C5.589 2 2 5.589 2 10C2 11.504 2.425 12.908 3.15 14.111L2.081 16.606C1.92 16.981 2.004 17.418 2.293 17.707C2.484 17.898 2.74 18 3 18C3.133 18 3.268 17.974 3.395 17.919L5.889 16.85C7.092 17.575 8.496 18 10 18C14.411 18 18 14.411 18 10C18 5.589 14.411 2 10 2Z" fill="#5C5F62" />
      </svg>
      Report wrong shipping info
    </section>

  );
};
